import { TmrBaseResource } from 'stylewhere/api'

export class ProductionOrderRows extends TmrBaseResource {
  static endpoint = 'api/v1/productionOrderRows' //tracking
}
